import {
  BackendEndpoints, carParkRole, ClientFileInnerType, ClientFileStatus, ClientFileType,
  CriticalDatasetLabels, criticalPopupMode,
  DangerousState,
  DetectorDirection, DetectorFoodDrink,
  DetectorFoodEat, DetectorSmokeDirection, HumanEntryGlasses,
  HumanEntryHair,
  HumanEntrySex,
  HumanEntryWearingType,
  LightConditionsSun, LightConditionsType,
  RecommendationType, RusavicCategories, UploadVideoTypes,
  UserCriticalEventConfirmation,
  UserCriticalEventRejection
} from '../enum'
import { localFiltersFields } from '@/models/map/CriticalEventLocalFilters'

export default {
  // application texts
  auth: {
    SignIn: 'Sign in',
    profile: 'Profile',
    adminPanel: 'Trips',
    charts: 'Statistics',
    reports: 'Reports',
    dataset: 'Dataset',
    carParks: 'Car parks',
    signOut: 'Sign out'
  },

  navbar: {
    main: 'Home',
    features: 'Features',
    papers: 'Papers',
    press: 'Press',
    patents: 'Int. property',
    diplomas: 'Diplomas'
  },

  policyAlert: {
    title: 'Cookie policy',
    description: `We use cookies and other tracking technologies to improve your browsing experience on site and analyze site traffic.
<a class="black--text" href='{0}'>Privacy Policy</a> page contains more information about this topic. By clicking <span class="font-weight-bold">"Accept"</span> button, you allow us to use cookies and other tracking technologies on this site.`,
    acceptText: 'By clicking <span class="font-weight-bold">"Accept"</span> button, you allow us to use cookies and other ' +
      'tracking technologies on this site.',
    acceptButton: 'Accept'
  },

  rusavic: {
    title: 'The multi-speaker audiovisual corpus RUSAVIC (RUSsian Audio-Visual speech In Cars)',
    text: '<div>The multi-speaker audiovisual corpus RUSAVIC (RUSsian Audio-Visual speech In Cars) includes a continuous Russian speech with multi-angle video and audio data. ' +
      'It contains recordings of 20 native Russian speakers. The database stores audio and video recordings of Russian speech, as well as information about data labeling. ' +
      'Data are collected in a synchronous way through several smartphones mounted on the vehicle dashboard and equipped with FullHD video camera and microphone. ' +
      'The script for the corpus consists of three dictionaries: 62 most frequent requests from driver to a smartphone, 33 letters of the Russian alphabet and 39 digits ' +
      '(including tens and hundreds). ' +
      'The corpus of Russian speech is intended for training and research of probabilistic models of the automatic recognition system of audiovisual Russian speech in the vehicle cabin. ' +
      'Recording of the speech corpus was carried out both in traffic conditions and in the idling vehicle, i.e. in full-scale and semi-natural conditions, ' +
      'as close as possible to the real conditions.</div>' +
      '<div class="my-2">The dataset example for one driver is available here: <a target="_blank" rel="noopener noreferrer" href="https://1drv.ms/u/s!Ar_DU2ygGWIUgvUKLF0LD3JDe5LrzA?e=IfoRMK">https://1drv.ms/u/s!Ar_DU2ygGWIUgvUKLF0LD3JDe5LrzA?e=IfoRMK</a></div>' +
      '<div class="my-2">To download the whole dataset, please, write email: <a href="mailto:alexey.kashevnik@iias.spb.su">alexey.kashevnik@iias.spb.su</a></div>' +
      '<div class="my-2">' +
      '<p>1. Kashevnik A., Lashkov I., Axyonov A., Ivanko D., Ryumin D., Kolchin A., Karpov A. Multimodal Corpus Design for Audio-Visual Speech Recognition in Vehicle Cabin. IEEE Access, IEEE. 2021. Vol. 9. P. 34986–35003.</p>' +
      '<p>2. Ivanko D., Ryumin D., Axyonov A., Kashevnik A., Karpov A. RUSAVIC Corpus: Russian Audio-Visual Speech in Cars. Proceedings of the 13th Language Resources and Evaluation Conference (LREC), Marseille, France, 20-25 June 2022Electronic, WWW. 2022. P. 1555–1559.</p>' +
      '<p>3. Ivanko D., Kashevnik A., Ryumin D., Kitenko A., Axyonov A., Lashkov I., Karpov A. MIDriveSafely: Multimodal Interaction for Drive Safely. 24th ACM International Conference on Multimodal Interaction (ICMI 2022), Bangalore, India, 7-11 November 2022ACM. 2022. P. 733–735.</p></div>',
    tabs: {
      'driver': 'Driver #{0}',
      'driver_10': 'Driver #1',
      'driver_20': 'Driver #2',
      'driver_30': 'Driver #3',
      'driver_40': 'Driver #4',
      [RusavicCategories.ALL_ROUTE]: 'Show route',
      [RusavicCategories.RESET_ROUTE]: 'Reset route',
      [RusavicCategories.GAS_STATION]: 'Route to gas station',
      [RusavicCategories.ROUTE_DURATION]: 'Route duration',
      [RusavicCategories.ROUTE_ESTIMATION]: 'Route estimation',
      [RusavicCategories.TRAFFIC_OVERALL]: 'Overall traffic situation',
      [RusavicCategories.JAM_SITUATION]: 'Road jam situation',
      [RusavicCategories.JAM_DURATION]: 'Road jam duration',
      [RusavicCategories.GAS_STATION_SEARCH]: 'Gas station search',
      [RusavicCategories.STREET]: 'Street',
      [RusavicCategories.HOME_REDIRECTION]: 'Go to home location',
      [RusavicCategories.LOCATE_NEAREST]: 'Locate nearest place',
      [RusavicCategories.GASOLINE_PRICE]: 'Gasoline cost',
      [RusavicCategories.MUSIC_TURN_ON]: 'Music turn on',
      [RusavicCategories.RADIO_TURN_ON]: 'Radio turn on',
      [RusavicCategories.AUDIOBOOK_TURN_ON]: 'Audiobook turn on',
      [RusavicCategories.MUSIC_TURN_OFF]: 'Music turn off',
      [RusavicCategories.SHUT_UP]: 'Please, be quit',
      [RusavicCategories.CALL_NUMBER]: 'Call number',
      [RusavicCategories.SEND_MESSAGE]: 'Send message',
      [RusavicCategories.SEND_EMAIL]: 'Send email',
      [RusavicCategories.ANSWER_CALL]: 'Answer call',
      [RusavicCategories.DECLINE_CALL]: 'Decline call',
      [RusavicCategories.BRIGHTNESS_INCREASE]: 'Increase brightness',
      [RusavicCategories.BRIGHTNESS_DECREASE]: 'Decrease brightness',
      [RusavicCategories.VOLUME_INCREASE]: 'Increase volume',
      [RusavicCategories.VOLUME_DECREASE]: 'Decrease volume',
      [RusavicCategories.TEMPERATURE_OUTSIDE]: 'Temperature outside',
      [RusavicCategories.ROUTE_CREATION]: 'Route creation',
      [RusavicCategories.AVOID_JAMS]: 'Avoid road jams',
      [RusavicCategories.STREET_SEARCH]: 'Street search',
      [RusavicCategories.RESTAURANT_SEARCH]: 'Restaurant search',
      [RusavicCategories.SET_TIMER]: 'Set timer',
      [RusavicCategories.WI_FI_TURN_ON]: 'Wi-fi turn om',
      [RusavicCategories.PLAY_LIST_TURN_ON]: 'Playlist turn on',
      [RusavicCategories.PARKING_SHOW]: 'Parking showing',
      [RusavicCategories.PARKING_SEARCH]: 'Parking searching',
      [RusavicCategories.ACCIDENT_AHEAD]: 'Accident ahead',
      [RusavicCategories.CALENDAR_SHOW]: 'Calendar showing',
      [RusavicCategories.REBOOT]: 'Reboot',
      [RusavicCategories.MASSAGE_BACK]: 'Massage back',
      [RusavicCategories.SUSPENSION_SOFT]: 'Suspension soften',
      [RusavicCategories.LEAVING_RUNAWAY_WARNING_TURN_OFF]: 'Leaving runaway warning turn off',
      [RusavicCategories.INTERIOR_LIGHT_TURN_ON]: 'Interior light turn on',
      [RusavicCategories.INTERIOR_LIGHT_TURN_OFF]: 'Interior light turn off',
      [RusavicCategories.AIR_CONDITIONER_TURN_ON]: 'Air conditioner turn on',
      [RusavicCategories.AIR_CONDITIONER_TURN_OFF]: 'Air conditioner turn off',
      [RusavicCategories.HEATING_TURN_ON]: 'Heating turn on',
      [RusavicCategories.HEATING_TURN_OFF]: 'Heating turn off',
      [RusavicCategories.SIGNALING_TURN_ON]: 'Signaling turn on'
    }
  },

  landing: {
    main: {
      title: 'is a driver monitoring application using smartphone camera and sensors',
      googleApp: 'Our app is available for Android mobile device! Download now to get started!',
      support: 'Contact us for support and suggestions: ',
      footer: '<a class="black--text" href="https://spcras.ru/en/">SPCRAS</a>, 39, 14 Line, St.Petersburg, 199178, Russia ',
      privacy: 'Privacy Policy'
    },
    functionality: {
      title: 'Features', // 'Monitoring the driver\'s behavior to identify dangerous states of fatigue and reduced attention while driving',
      phone: {
        title: 'Driving safety',
        description: 'Generates audible alerts and context-based personalized recommendations for a driver'
      },
      map: {
        title: 'Easy to use',
        description: 'Launch the mobile application side by side with the usual driver\'s navigation system'
      },
      stats: {
        title: 'Driving statistics',
        description: 'Shows statistics of you trips on the map to help improve driver safety',
        labels: [
          'Trip route with dangerous state',
          'Trip stats'
        ]
      },
      personification: {
        title: 'Personification',
        description: 'System will learn based on the driver data'
      }
    },
    papers: {
      title: 'Project publications',
      conferences: 'Conferences',
      journals: 'Journals'
    },
    press: {
      title: 'Project press'
    },
    patents: {
      title: 'Intellectual property'
    },
    diplomas: {
      title: 'Diplomas'
    }
  },

  statisticsCard: {
    title: 'Total statistics'
  },

  legalInformation: {
    title: 'Privacy Policy',
    header: '<p>Effective date: January 14, 2019</p> ' +
      '<p>Drive Safely ("us", "we", or "our") operates the Drive Safely mobile application (the "Service").</p>' +
      '<p>Drive Safely is provided at no cost and is intended for use as is.</p>' +
      '<p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p> ' +
      '<p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. ' +
      'Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>',
    informationCollection: {
      title: 'Information Collection And Use',
      subheader: '<p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>',
      dataTypes: {
        title: 'Types of Data Collected',
        personalData: {
          title: 'Personal Data',
          description: '<p>While using our Service, we may ask you to provide us with certain personally identifiable information ' +
            'that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>',
          list: [
            'Email address', 'Driver experience', 'Gender', 'Date of birth', 'Usage Data'
          ]
        }
      },
      usageData: {
        title: 'Usage data',
        description: '<p>We may also collect information when you access the Application by a mobile device ("Usage Data").</p>' +
          '<p>When you access the Application, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID,' +
          ' the IP address of your mobile device, your mobile operating system, unique device identifiers, contacts, data obtained accessing the camera, microphone and similar devices)' +
          ' and other diagnostic data.</p>' +
          '<p>The Application may use GPS technology (or other similar technology) to determine your current location in order to determine the city you are located in and give relevant ' +
          'context recommendations. If you do not want us to use your location for the purposes set forth above, you should turn off the location services for the mobile application located ' +
          'in your account settings or in your mobile phone settings.</p>'
      }
    },
    useOfData: {
      title: 'Use of Data',
      description: '<p>Drive Safely uses the collected data for various purposes:</p>',
      list: [
        'To provide and maintain the Service', 'To notify you about changes to our Service',
        'To allow you to participate in interactive features of our Service when you choose to do so',
        'To provide customer care and support',
        'To provide analysis or valuable information so that we can improve the Service',
        'To monitor the usage of the Service',
        'To protect against legal liability'
      ]
    },
    transferOfData: {
      title: 'Transfer Of Data',
      description: '<p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction ' +
        'where the data protection laws may differ than those from your jurisdiction.</p> <p>If you are located outside Russian Federation and choose to provide information to us, please note that we transfer the data, ' +
        'including Personal Data, to Russian Federation and process it there.</p> <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p> ' +
        '<p>Drive Safely will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless ' +
        'there are adequate controls in place including the security of your data and other personal information.</p>'
    },
    disclosureOfData: {
      title: 'Disclosure Of Data',
      legalRequirements: {
        title: 'Legal Requirements',
        description: '<p>Drive Safely may disclose your Personal Data in the good faith belief that such action is necessary to:</p>',
        list: [
          'To comply with a legal obligation',
          'To protect and defend the rights or property of Drive Safely',
          'To prevent or investigate possible wrongdoing in connection with the Service',
          'To protect the personal safety of users of the Service or the public',
          'To protect against legal liability'
        ]
      }
    },
    securityOfData: {
      title: 'Security Of Data',
      description: '<p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. ' +
        'While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>',
      cookieInformation: {
        title: 'Cookie information',
        description: '<p>We use cookie files for identifying user on this site. ' +
          'We place some of the cookies on the websites ourselves, while other cookies are placed by third parties. ' +
          'Third-party cookies may collect data outside our websites as well.</p>',
        listTitle: 'The site use the following types of cookies:',
        list: [
          '<p class="font-weight-bold">Functional cookies</p> ' +
          '<p>These cookies allow user to have access to secured parts of the site. Functional cookies are not used for marketing purposes.</p>',
          '<p class="font-weight-bold">Analytic cookies</p> <p>These cookies help us to collect information about how users works with the site. <a href="https://yandex.com/support/metrica/general/cookie-usage.html">Yandex AppMetrica</a> is example of this type of cookies.</p>'
        ]
      },
      geographicInformation: {
        title: 'Geographic information',
        description: 'We use static images of navigation maps for screenshots in Google Play and this site.',
        list: [
          '<p class="font-weight-bold">OpenStreetMap</p>' +
          '<p>OpenStreetMap (OSM) is a collaborative project to create a free editable map of the world.</p>' +
          '<p>Data is available under the Open Database Licence. ' +
          'For more information, please, visit full text of license: <a href="https://www.openstreetmap.org/copyright/en">https://www.openstreetmap.org/copyright/en</a></p>'
        ]
      },
      analytics: {
        title: 'Analytics',
        description: 'We may use third-party Service Providers to monitor and analyze the use of our Service.',
        list: [
          '<p class="font-weight-bold">AppMetrica</p>' +
          '<p>AppMetrica is a web analytics service offered by Yandex that provides usage analytics and crash analytics. Yandex uses the data collected to track and monitor the use of our Service.</p>' +
          '<p>For more information on the privacy practices of Yandex, please visit the Yandex.Metrica Privacy & Terms web page: ' +
          '<a href="https://metrica.yandex.com/about/info/privacy-policy">https://metrica.yandex.com/about/info/privacy-policy</a></p>'
        ]
      }
    },
    linksToOtherSites: {
      title: 'Links To Other Sites',
      description: '<p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit.</p>' +
        '<p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>'
    },
    childrenPrivacy: {
      title: 'Children\'s Privacy',
      description: '<p>Our Service does not address anyone under the age of 18 ("Children").</p>' +
        '<p>We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</p>'
    },
    changesToThisPrivacyPolicy: {
      title: 'Changes To This Privacy Policy',
      description: '<p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>' +
        '<p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.</p>' +
        '<p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>'
    },
    contactUs: {
      title: 'Contact Us',
      description: '<p>If you have any questions about this Privacy Policy, do not hesitate to contact us:</p>',
      list: [
        'By email: <a href="mailto:support@mobiledrivesafely.com">support@mobiledrivesafely.com</a>'
      ]
    }
  },

  map: {
    travelToolbar: {
      travel: 'Trip',
      timePretext: 'from'
    },
    travelMap: {
      toolbar: {
        map: 'Map'
      },
      localFilters: {
        tooltip: 'Event filters',
        title: 'Event filters',
        sections: {
          [localFiltersFields.DANGEROUS_STATE_FILTERS]: 'Event type',
          [localFiltersFields.USER_STATE_FILTERS]: 'Event state'
        }
      },
      purePointCard: {
        title: 'Path data',
        clearAll: 'Clear all path data'
      },
      iconedTravelStats: {
        start: 'Start',
        startProgram: 'Program start',
        startReal: 'Trip start',
        finish: 'Finish',
        correctDate: 'Date from events',
        errorDate: 'Date from road_trip table'
      }
    },
    managerMap: {
      toolbarTitle: 'Drivers',
      travelCard: {
        start: 'Start'
      },
      localFilters: {
        title: 'Trips filtration',
        filters: {
          isOnlyNano: 'Is only Nano drivers?',
          timeRangeFilter: {
            title: 'Get trips within time range'
          }
        },
        apply: 'Refresh table'
      },
      headers: {
        style: 'Style',
        username: 'User',
        travels: 'Trips',
        distance: 'Distance (km)',
        latestTrip: 'Latest trip',
        drowsiness: 'Drowsiness',
        distraction: 'Distraction',
        [DangerousState.DISTRACTION_NO_ATTENTION]: 'Distraction state',
        [DangerousState.DISTRACTION_NO_FACE]: 'Face not found',
        nobelt: 'No belt',
        cameraSabotage: 'Camera sabotage',
        cellphoneUse: 'Cellphone usage',
        eatingCount: 'Eating',
        smokingCount: 'Smoking'
      },
      style: {
        green: 'The frequency of critical situations is low',
        yellow: 'The frequency of critical situations is average',
        red: 'The frequency of critical situations is large'
      },
      tripCard: {
        tripStart: 'Trip start',
        distance: 'Distance'
      },
      filterHeaders: {
        latestTrip: 'Trip dates',
        duration: 'Duration',
        lowerBound: 'Lower bound',
        upperBound: 'Upper bound',
        timeRange: 'Time range',
        dateRange: 'Date range',
        driverHeader: 'Driver name'
      },
      noTrips: 'There is no available travels',
      defaultSettings: 'Default settings',
      demoVideo: 'Selected videos',
      syncDefaultSettings: 'Synchronize',
      syncAll: 'Synchronize all drivers',
      defaultSettingsUsers: 'Drivers',
      fineTuningSettings: 'Fine tuning settings',
      uncheckedStates: 'Unchecked states: {0}',
      reportOff: 'Trip is excluded from reports'
    },
    mapDialog: {
      nextTrip: 'Next trip',
      previousTrip: 'Previous trip',
      tripReportStatus: 'Reports',
      tripReportStatusFailure: 'An error occurred while changing the trip report status!',
      tripReportStatusSuccess: 'Trip report status was successfully changed',
      tripReportDialog: {
        title: 'Trip report status confirmation',
        includeText: 'Do you want to include this trip to reports?',
        excludeText: 'Do you want to exclude this trip from reports?',
        confirm: 'Yes',
        reject: 'No'
      },
      tripAdditionalStatisticsLabel: 'Additional trip statistics download',
      tripAdditionalStatisticsFailure: 'An error occured while additional trip statistics requesting!'
    },
    tableFilter: {
      all: 'All',
      clear: 'Clear',
      clearAll: 'Clear all',
      reset: 'Reset',
      date: 'Date',
      duration: {
        seconds: 'seconds',
        minutes: 'minutes',
        hours: 'hours',
        days: 'days'
      }
    },
    driverTrips: {
      actions: {
        view: 'View trip',
        stats: 'Download statistics',
        video: 'Download critical video archive'
      }
    },
    tripDownload: {
      title: 'Download trip statistics',
      statisticsType: {
        title: 'Statistics type: ',
        pure: 'Pure',
        critical: 'Critical'
      },
      formatType: {
        title: 'Format type'
      },
      download: 'Download'
    },
    videoDownload: {
      title: 'Download critical video archive',
      text: 'There will be {0} videos in archive. It may take some time to download it all.',
      download: 'Download'
    },
    tripScroll: {
      title: 'Another trips'
    },
    travelStatsCard: {
      title: 'Trip information',
      measurementsDialogButton: 'Travel data fetching measurement',
      measurementsDialog: {
        title: 'Travel data fetching measurement (in seconds)'
      },
      clientFilesDialogButton: 'Driver files'
    },
    travelTabs: {
      calendar: 'Calendar',
      driver: 'Driver'
    },
    travelSelector: {
      toolbarTitle: 'Trip selection',
      calendar: 'Calendar',
      travels: 'Trips',
      show: 'Show',
      userSelector: {
        drivers: 'Drivers',
        placeholder: 'Start typing to search...'
      }
    },
    travelStats: {
      toolbarTitle: 'Trip statistics',
      averageSpeed: {
        title: 'Avg. speed',
        postfix: 'km/h'
      },
      maxSpeed: {
        title: 'Max. speed',
        postfix: 'km/h'
      },
      maxAcceleration: {
        title: 'Max. acceleration',
        postfix: 'm/s<sup>2</sup>'
      },
      distance: {
        title: 'Distance',
        postfix: 'km'
      },
      duration: {
        title: 'Duration'
      },
      distractionCount: {
        title: 'Distraction count'
      },
      distractionNoAttentionCount: {
        title: 'No attention count'
      },
      distractionNoFaceCount: {
        title: 'No face count'
      },
      drowsinessCount: {
        title: 'Drowsiness count'
      },
      yawningCount: {
        title: 'Yawning count'
      },
      nobeltCount: {
        title: 'No belt count'
      },
      cameraSabotage: {
        title: 'Camera sabotage count'
      },
      cellphoneUse: {
        title: 'Cellphone usage count'
      },
      eatingCount: {
        title: 'Eating count'
      },
      smokingCount: {
        title: 'Smoking count'
      },
      dateStart: {
        title: 'Trip start'
      },
      actions: {
        title: 'Actions'
      }
    },
    mapHelp: {
      title: 'Critical event possible states',
      unknownState: 'Unknown event',
      ignoredState: 'Ignored event',
      approvedState: 'Approved event',
      rejectedState: 'Rejected event',
      retrainedState: 'Retrained event',
      approvedRetrainedState: 'Retrained approved event'
    },
    criticalPopup: {
      title: {
        [DangerousState.DISTRACTION]: 'Distraction',
        [DangerousState.DISTRACTION_NO_ATTENTION]: 'Distraction state',
        [DangerousState.DISTRACTION_NO_FACE]: 'Face not found',
        [DangerousState.DROWSINESS]: 'Drowsiness',
        [DangerousState.BELT_NOT_FASTEN]: 'Belt not fasten',
        [DangerousState.YAWNING]: 'Yawning',
        [DangerousState.CAMERA_SABOTAGE]: 'Camera sabotage',
        [DangerousState.CAMERA_OFF]: 'Camera not working',
        [DangerousState.CELLPHONE_USE]: 'Cell phone usage',
        [DangerousState.EATING]: 'Eating detected',
        [DangerousState.SMOKING]: 'Smoking detected',
        [DangerousState.UNKNOWN]: 'Unknown danger'
      },
      criticalMode: {
        [criticalPopupMode.DATASET]: 'Map',
        [criticalPopupMode.MAP]: 'Critical dataset'
      },
      criticalVideo: {
        title: 'Sync-play videos'
      },
      stateHelper: {
        [UserCriticalEventConfirmation.APPROVE]: 'Critical event was approved',
        [UserCriticalEventConfirmation.REJECT]: 'Critical event was rejected',
        [UserCriticalEventConfirmation.RETRAIN]: 'Critical event was retrained'
      },
      recommendations: {
        [RecommendationType.DRINK_COFFEE_CAFE]: 'Drink 2 cups of coffee',
        [RecommendationType.DRINK_COFFEE_HOTEL]: 'Drink 2 cups of coffee',
        [RecommendationType.RADIO_AND_MUSIC_ON]: 'Listen to radio and music',
        [RecommendationType.RADIO_AND_MUSIC_OFF]: 'Turn off radio and music',
        [RecommendationType.TALK_WITH_PASSENGERS]: 'Talk to passengers',
        [RecommendationType.NO_TALK_WITH_PASSENGERS]: 'Stop talking with passengers without being distracted',
        [RecommendationType.CONCENTRATE_ON_ROAD]: 'Concentrate on the road!',
        [RecommendationType.COOL_CAR_INTERIOR]: 'Cool the car interior',
        [RecommendationType.SING_YOURSELF]: 'Sing to yourself',
        [RecommendationType.PULL_OVER]: 'Pull over and take a nap, please',
        [RecommendationType.ADJUST_CABIN_LIGHTNING]: 'Adjust the cabin lightning',
        [RecommendationType.STOP_NEXT_REST_AREA]: 'Stop by next rest area if it is not dark',
        [RecommendationType.CHANGE_DRIVERS]: 'Change drivers can illuminate drowsiness',
        [RecommendationType.STOP_STRETCH_EXCERSIZE]: 'Stop to stretch, exercise or walk around',
        [RecommendationType.ADJUST_SEAT_POSITION]: 'Adjust the cabin lightning'
      },
      nextEvent: 'Next event',
      previousEvent: 'Previous event',
      mapPopup: '10 seconds before the event',
      sections: {
        general: {
          title: 'General',
          eventStart: 'Event start',
          eventEnd: 'Event end',
          duration: 'Duration',
          recommendation: 'Recommendation',
          criticalParamValue: 'Crit. values',
          locationAccuracy: 'Accuracy',
          satelliteCount: 'Satellites',
          fixedCoordinates: 'Event coordinates was fixed because of incorrect satellite count and/or location accuracy!'
        },
        titles: {
          general: 'General',
          rejection: 'Rejection',
          video: 'Video',
          settings: 'Settings',
          deviceInfo: 'Device info',
          criticalParamValue: 'Crit. values',
          tag: 'Meta info',
          videoTag: 'Video'
        },
        context: {
          title: 'Context',
          averageSpeed: {
            title: 'Average speed',
            postfix: 'km/h'
          },
          averageAcceleration: {
            title: 'Average acceleration',
            postfix: 'm/s<sup>2</sup>'
          },
          maxAcceleration: {
            title: 'Maximum acceleration',
            postfix: 'm/s<sup>2</sup>'
          },
          minAcceleration: {
            title: 'Minimum acceleration',
            postfix: 'm/s<sup>2</sup>'
          },
          distance: {
            title: 'Distance',
            postfix: 'km'
          }
        },
        video: {
          title: 'Video',
          tabs: {
            [UploadVideoTypes.DRIVER]: 'Driver',
            [UploadVideoTypes.ROAD]: 'Road'
          }
        },
        settings: {
          title: 'Settings'
        },
        deviceInfo: {
          title: 'Device Info'
        }
      },
      rejectedEvent: {
        reason: 'Reason: ',
        retrain: 'Retrain: '
      },
      retrainStates: {
        title: 'State retraining',
        noneSelected: 'State is not selected',
        emptyStateError: 'It is necessary to select retrain state!'
      },
      rejectDialog: {
        title: 'State rejecting',
        rejectComment: 'Comment',
        retrainLabel: 'Retrain state',
        noneSelected: 'Reason is not selected',
        emptyStateError: 'It is necessary to select reject reason!',
        states: {
          [UserCriticalEventRejection.BUG]: 'System bug',
          [UserCriticalEventRejection.SCRATCH]: 'Scratch',
          [UserCriticalEventRejection.AUDIO_PANEL]: 'Audio panel viewing',
          [UserCriticalEventRejection.ERROR]: 'Detection error',
          [UserCriticalEventRejection.SUN_GLARE]: 'Sun glare',
          [UserCriticalEventRejection.RETRAIN]: 'Retrain',
          [UserCriticalEventRejection.BLINK]: 'Blink',
          [UserCriticalEventRejection.GLASSES]: 'Glasses',
          [UserCriticalEventRejection.OTHER]: 'Other'
        },
        help: {
          [UserCriticalEventRejection.BUG]: 'Sabotage at the very start of the launch',
          [UserCriticalEventRejection.SCRATCH]: 'The driver scratches his nose, ear, head, eye while looking at the road',
          [UserCriticalEventRejection.AUDIO_PANEL]: 'The driver looks in the area of the radio on the right, most often there is a telephone',
          [UserCriticalEventRejection.ERROR]: 'The driver’s behavior is safe and consistent with the type of event that the system has detected',
          [UserCriticalEventRejection.SUN_GLARE]: 'False alarms due to sun glare',
          [UserCriticalEventRejection.RETRAIN]: 'The system detected the wrong type or did not notice it at all',
          [UserCriticalEventRejection.BLINK]: 'Bright sun, eyes narrowed',
          [UserCriticalEventRejection.GLASSES]: 'Sunglasses driver',
          [UserCriticalEventRejection.OTHER]: 'Any other reasons for the incorrect determination of the type of event'
        }
      },
      buttons: {
        confirm: 'Confirm',
        reject: 'Reject',
        retrain: 'Retrain',
        retrainApproved: 'Confirm with retrain'
      },
      userConfirm: {
        isTurning: 'is turning?',
        isCameraCorrect: 'Is camera attached correctly?',
        isLookDown: 'Is driver looks down?',
        isWearingMask: 'Is driver wearing mask?'
      },
      criticalStatisticsFilterMenu: {
        title: 'Duration filtration',
        popup: 'Additional statistics for critical events'
      },
      allCameraCorrectDialog: {
        button: 'Confirm the correct camera position during the entire trip',
        title: 'Confirmation of camera position throughout the trip',
        text: 'When you press the <span class="light-green--text"> "Yes"</span> button, the "Is camera attached correctly?" field will be confirmed for all events.',
        confirm: 'Yes',
        reject: 'No'
      },
      allIsWearingMaskDialog: {
        button: 'Confirm that driver wears mask during the entire trip',
        title: 'Driver mask wearing confirmation',
        text: 'When you press the <span class="light-green--text"> "Yes"</span> button, the "Is driver wearing mask?" field will be confirmed for all events.',
        confirm: 'Yes',
        reject: 'No'
      }
    },
    drowsinessCaption: [
      'Extremely alert',
      'Very alert',
      'Alert',
      'Rather alert',
      'Neither alert nor sleepy',
      'Some signs of sleepiness',
      'Sleepy, but no difficulty remaining awake',
      'Sleepy, some effort to keep alert',
      'Extremely sleepy, fighting sleep'
    ],
    userFeedbackForm: {
      rateTravel: 'Rate the trip',
      travelRating: 'Trip rating',
      drowsinessRating: 'Drowsiness rating',
      drivingStyle: {
        title: 'Driving style',
        calm: 'Calm',
        aggressive: 'Aggressive'
      }
    },
    userFeedback: {
      travelRating: 'Trip rating',
      drowsiness: 'Drowsiness:',
      drivingStyle: 'Driving style'
    },
    textCopyPopup: {
      title: 'Trip link',
      copy: 'Copy',
      success: 'Link was copied!',
      failure: 'Error was occurred while copying!'
    },
    driverSettings: {
      title: '{0} settings',
      defaultSettingsTitle: 'Default settings (id = {0})',
      tabs: {
        situation: 'Dangerous situation',
        distraction: 'Distraction',
        distractionNoFace: 'Face absence',
        distractionNoAttention: 'Lack of attention',
        drowsiness: 'Drowsiness',
        yawn: 'Yawn',
        autoCalibrate: 'Auto-calibrate',
        belt: 'Belt',
        general: 'General',
        sabotage: 'Camera sabotage',
        cellphone: 'Cellphone usage',
        eating: 'Eating',
        smoking: 'Smoking',
        cameraOff: 'Sabotage, camera does not working',
        handsFrame: 'Hands in frame',
        notifications: 'Notifications',
        serviceMessages: 'Service Messages'
      },
      tabContentTitles: {
        situation: 'Dangerous state time frames',
        distraction: 'Distraction parameters',
        drowsiness: 'Drowsiness parameters',
        yawn: 'Yawn parameters',
        autoCalibrate: 'Auto-calibrate parameters',
        belt: 'Belt parameters',
        general: 'Distraction parameters',
        filters: 'Filters',
        settings: 'Settings'
      },
      iconedLabels: {
        autoCalibrate: 'Auto-calibration',
        deviceSettings: 'Device settings',
        statisticsSettings: 'Statistics settings',
        soundSettings: 'Sound settings',
        recommendationAndDangerousStateSettings: 'Recommendation and states settings',
        detectorsSettings: 'Detectors settings',
        detectorsStopSettings: 'Detector shutdown settings'
      },
      response: {
        ok: 'Driver profile is updated',
        error: 'Something wrong with driver profile updating! View logs for further information',
        syncOk: 'Default settings synchronization is completed',
        syncError: 'Something wrong with default settings synchronization! View logs for further information',
        driverSyncOk: 'Synchronization with default settings is completed',
        driverSyncError: 'Something wrong with drivers default settings synchronization! View logs for further information'
      },
      labels: {
        intervalBetweenDetectDangersBetween: 'Interval to detect between dangerous states (ms)',
        periodInDetectDanger: 'Period to detect dangerous state (ms)',
        isDetectDistraction: 'Detect distraction?',
        leftHeadAnglePref: 'Head turn left °',
        rightHeadAnglePref: 'Head turn right °',
        calibratedHeadAngleYawPref: 'Head turn angle offset °',
        calibratedHeadAnglePitchPref: 'Head tilt angle offset °',
        upHeadAnglePref: 'Head tilt up °',
        downHeadAnglePref: 'Head tilt down °',
        isDetectDrowsiness: 'Detect drowsiness?',
        leftEyeOpennessPercentagePref: 'Ratio of left eye openness (0–100%)',
        rightEyeOpennessPercentagePref: 'Ratio of right eye openness (0–100%)',
        perclosPref: 'PERCLOS (0..1)',
        headRotateAngleDrowsinessDetect: 'Head rotate angle limit to detect drowsiness °',
        yawnCount: 'Yawning count',
        thresholdMouthOpenDetect: 'Threshold mouth open detect',
        yawnPeriodDetect: 'Period to detect yawning state (s)',
        driverStatisticsEnabled: 'Send statistics?',
        driverStatisticsSyncWifi: 'Send statistics only via WiFi?',
        trainModeEnabled: 'Training mode enabled?',
        finishAppOnCloseNavig: 'Finish app when navigation closes?',
        settingPlayBeepEvent: 'Play warning beep for dangerous event?',
        settingPlayBeepDangerEvent: 'Play warning beep for dangerous state?',
        isVibrate: 'Vibrate on touch?',
        audioLevelPref: 'Audio level',
        screenBrightness: 'Screen brightness',
        intervalBetweenRecommendationsSec: 'Recommendation interval (s)',
        travelTimeLastStopHours: 'Time to stop at hotel/cafe/gas station (hh.mm)',
        autoCalibrateEnabled: 'Enable head auto calibration?',
        autoCalibrateSpeed: 'Min speed to calibrate (km/h)',
        autoCalibrateFirstPeriod: 'First interval to calibrate head angles (sec)',
        autoCalibrateRefineInterval: 'Period to refine head angles (sec)',
        isDetectSeatBelt: 'Detect seat belt?',
        periodDetectDrowsiness: 'State detection period (ms)',
        minFramesDetectDrowsiness: 'Minimal state detection count',
        minFramesDetectDistraction: 'Minimal state detection count',
        isDetectCameraSabotage: 'Detect camera sabotage?',
        maxFramesDetectSabotage: 'Image window size',
        minFramesDetectSabotage: 'State detection count',
        notificationVocalize: 'Speak',
        notificationInterval: 'Re-state period (s)',
        confidenceDetectGazeRadio: 'Gaze radio detection confidence',
        mirrorImage: 'Mirror camera image horizontally?',
        mirrorImageDriver: 'Mirror driver camera image horizontally?',
        mirrorImageRoad: 'Mirror road camera image horizontally?',
        periodDetectBelt: 'State detection period (ms)',
        periodDetectSabotage: 'State detection period (ms)',
        headTiltAngleDrowsinessDetect: 'Head tilt angle limit to detect drowsiness °',
        mouthWidthRatioSmile: 'Mouth width on smile ratio (0..1)',
        distractionIntervalSpeedStart: 'Distraction interval speed start (km/h)',
        distractionIntervalTimeDetectStart: 'Distraction interval time detect start (ms)',
        distractionIntervalSpeedEnd: 'Distraction interval speed end (km/h)',
        distractionIntervalTimeDetectEnd: 'Distraction interval time detect end (ms)',
        showServiceMessages: 'Use',
        isDetectCellPhone: 'Detect cellphone?',
        periodDetectCellPhone: 'State detection period (ms)',
        confidenceDetectCellPhone: 'Cellphone detection confidence',
        isDetectEating: 'Detect eating?',
        periodDetectEating: 'State detection period (ms)',
        confidenceDetectEating: 'Eating detection confidence',
        isDetectSmoking: 'Detect smoking?',
        periodDetectSmoking: 'State detection period (ms)',
        confidenceDetectSmoking: 'Smoking detection confidence',
        mouthWidthCalibrated: 'Mouth width calibration',
        isDetectDistractionNoFace: 'Detect face absence?',
        isDetectDistractionNoAttention: 'Detect lack of attention?',
        ratioFramesDistractionNoFace: 'No face frames ratio',
        ratioFramesDistractionNoAttention: 'No attention frames ratio',
        timeDetectOneYawn: 'Time to detect one yawn (ms)',
        showDebugInfoVideo: 'Show debug information on video',
        confidenceDetectFrontBeltTop: 'Front belt top detection confidence',
        confidenceDetectFrontBeltBottom: 'Front belt bottom detection confidence',
        isDetectBackBelt: 'Detect belt back?',
        confidenceDetectBackBeltTop: 'Back belt top detection confidence',
        confidenceDetectBackBeltBottom: 'Back belt bottom detection confidence',
        detectorStopRepeatCount: 'Detector stop repeat count',
        detectorStopActivatePeriod: 'Detector stop activate period (s)',
        detectorStopSuspendTime: 'Detector stop suspend time (s)',
        isDetectCameraCalibrate: 'Detect camera calibration?',
        yawnFramesRatioDetect: 'Minimum frame rate for yawning detection',
        minSpeedDrowsiness: 'Min. speed to detect dangerous state (km/h)',
        minSpeedDistractionNoFace: 'Min. speed to detect dangerous state (km/h)',
        minSpeedDistractionNoAttention: 'Min. speed to detect dangerous state (km/h)',
        minSpeedCameraSabotage: 'Min. speed to detect dangerous state (km/h)',
        minSpeedBeltNotFasten: 'Min. speed to detect dangerous state (km/h)',
        minSpeedCellPhone: 'Min. speed to detect dangerous state (km/h)',
        minSpeedSmoking: 'Min. speed to detect dangerous state (km/h)',
        minSpeedEating: 'Min. speed to detect dangerous state (km/h)',
        beltModelFramesPerSecond: 'Belt neural network processing (frame/s) ',
        percentFramesDetectBelt: 'Unfastened belt sutiation percentage',
        percentFramesDetectPhone: 'Cellphone situation percentage',
        percentFramesDetectEating: 'Eating situation percentage',
        percentFramesDetectSmoking: 'Smoking situation percentage',
        detectorLowLightThreshold: 'Min light threshold for detectors',
        imageRotateAngle: 'Image rotate angle (clockwise)'
      },
      unsavedDialog: {
        title: 'Unsaved changes detected!',
        text: 'Do you really want to quit without saving?',
        return: 'Return'
      },
      syncDialog: {
        title: 'Synchronization confirmation',
        textSingle: 'Do you want to synchronize this driver?',
        textSelected: 'Do you want to synchronize selected drivers?',
        textAll: 'Do you want to synchronize ALL drivers?',
        reject: 'No',
        confirm: 'Yes'
      },
      sync: 'Synchronize with default settings'
    },
    demoVideo: {
      title: 'Selected videos',
      videoType: {
        title: 'Video type',
        demo: 'Demo',
        dataset: 'Dataset'
      },
      stateSelector: {
        title: 'Select dangerous states',
        allSelected: 'All states are selected'
      }
    },
    requests: {
      files: 'Driver files',
      syncFileData: 'Get driver files',
      emptyData: 'Driver hasn\'t uploaded anything yet. The request have been already sent.',
      requestFile: 'Request file',
      showFile: 'Show file',
      downloadFile: 'Download file',
      historyLog: 'File history',
      tabs: {
        [ClientFileType.VIDEO]: 'Video ({0})',
        [ClientFileType.LOG]: 'Log ({0})'
      },
      dataIterator: {
        name: 'File',
        type: 'Type',
        time: 'Time',
        innerType: 'Category',
        size: 'Size',
        status: 'Status',
        actions: 'Actions',
        search: 'Filename / driver',
        filters: 'Filters',
        states: {
          [ClientFileStatus.REQUESTED]: 'Requested',
          [ClientFileStatus.INCOMPLETE]: 'Not requested',
          [ClientFileStatus.SAVED]: 'Saved',
          [ClientFileStatus.LOST]: 'Lost'
        },
        categories: {
          [ClientFileInnerType.DASHCAM_DRIVER]: 'Dashcam (driver)',
          [ClientFileInnerType.DASHCAM_ROAD]: 'Dashcam (road)',
          [ClientFileInnerType.CRITICAL_VID_DRIVER]: 'Event video (driver)',
          [ClientFileInnerType.CRITICAL_VID_ROAD]: 'Event video (road)',
          [ClientFileInnerType.LOGS_APP_PURE]: 'App files',
          [ClientFileInnerType.LOGS_APP_ARCHIVE]: 'App logs',
          [ClientFileInnerType.LOGS_SYSTEM]: 'System files',
          [ClientFileInnerType.UNKNOWN]: 'No category',
          null: 'No category'
        },
        types: {
          [ClientFileType.VIDEO]: 'Videos',
          [ClientFileType.LOG]: 'Logs'
        },
        statesNumbered: {
          [ClientFileStatus.REQUESTED]: 'Requested: {0}',
          [ClientFileStatus.INCOMPLETE]: 'Not requested: {0}',
          [ClientFileStatus.SAVED]: 'Saved: {0}',
          [ClientFileStatus.LOST]: 'Lost: {0}'
        }
      }
    }
  },
  mapSettings: {
    title: 'General settings',
    titleNew: 'New dataset event',
    titleOld: 'Existed dataset event',
    videoSettingsTitle: 'Video settings',
    hideReviewedEvents: 'Hide reviewed critical events',
    hideAllEventsExceptAccepted: 'Hide all events except approved',
    hideSmallTrips: 'Hide small trips',
    hideViewedTrips: 'Hide trips with all viewed critical events',
    clusterEvents: 'Cluster critical events',
    clusterEventTimePeriod: 'Critical event time period (ms)',
    autoScrollManipulatedEvents: 'Auto scroll events on status manipulation',
    videoWidth: 'Video width'
  },
  timezoneSettings: {
    title: 'Timezone setting',
    isActive: 'Use selected timezone',
    userTimezone: 'Choose timezone'
  },
  videoSettings: {
    title: 'Video settings',
    videoWidth: 'Driver video width',
    videoRoadWidth: 'Road video width',
    autoPlayVideo: 'Video autoplay?'
  },
  criticalDataset: {
    title: 'Critical dataset',
    labels: {
      [CriticalDatasetLabels.SLIDES]: 'Gallery',
      [CriticalDatasetLabels.HUMAN]: 'Human',
      [CriticalDatasetLabels.LIGHT_CONDITIONS]: 'Light conditions',
      [CriticalDatasetLabels.ACTIONS]: 'Actions',
      [CriticalDatasetLabels.DETECTORS]: 'Detectors'
    },
    slides: {
      alert: 'Critical video slides loading is failed! Please, contact the support team.'
    },
    buttons: {
      next: 'Next',
      previous: 'Previous',
      send: 'Send'
    },
    popup: {
      success: 'Dataset entry was applied!',
      failure: 'Dataset entry was denied.'
    },
    [CriticalDatasetLabels.HUMAN]: {
      sex: 'Sex:',
      glasses: 'Does driver wear glasses?',
      glassesDataset: 'Driver wears glasses',
      wearingType: 'Driver wearing',
      wearingTypeComment: 'Driver wearing comment',
      wearingColorBeltSimilar: 'Is wearing has similar color with belt?',
      wearingColorBeltSimilarDataset: 'Wearing has similar color with belt',
      hair: 'Long hair?',
      hairDataset: 'Long hair'
    },
    [CriticalDatasetLabels.LIGHT_CONDITIONS]: {
      type: 'Conditions',
      sun: 'Sun direction',
      rain: 'Is rain?',
      rainDataset: 'Rain'
    },
    [CriticalDatasetLabels.ACTIONS]: {
      handsOnWheel: 'Are hands on wheel (partly hide the belt)?',
      handsOnWheelDataset: 'Hands on wheel',
      headphones: 'Are wired headphones used?',
      headphonesDataset: 'Wired headphones',
      leftHandHidesBelt: 'Is left hand hides the belt?',
      leftHandHidesBeltDataset: 'Left hand hides the belt',
      rightHandHidesBelt: 'Is right hand hides the belt?',
      rightHandHidesBeltDataset: 'Right hand hides the belt'
    },
    [CriticalDatasetLabels.DETECTORS]: {
      beltFasten: 'Does belt fasten?',
      beltFastenDataset: 'Belt is fasten',
      beltFastenBehindBack: 'Does belt fasten behind back?',
      beltFastenBehindBackDataset: 'Belt is fasten behind back?',
      phoneFront: 'Is phone upfront?',
      phoneFrontDataset: 'Upfront phone',
      phoneAroundEar: 'Phone around ear direction:',
      phoneAroundEarDataset: 'Phone around ear direction:',
      phoneKeptByShoulder: 'Phone is kept by shoulder direction:',
      phoneKeptByShoulderDataset: 'Phone is kept by shoulder direction:',
      messagePhoneVisible: 'Is phone visible while message writing?',
      messagePhoneVisibleDataset: 'Message writing, phone is visible?',
      eatState: 'Driver eats',
      drinkState: 'Driver drinks',
      cigaretteState: 'Driver smokes cigarette',
      cigaretteStateDataset: 'Cigarette',
      pipeState: 'Driver smokes pipe',
      pipeStateDataset: 'Pipe',
      eCigaretteState: 'Driver smokes electronic cigarette',
      eCigaretteStateDataset: 'Electronic cigarette',
      faceIntersection: 'Face intersection',
      beltIntersection: 'Belt intersection',
      holdedObject: 'Object is holded'
    },
    enums: {
      HumanEntrySex: {
        [HumanEntrySex.MALE]: 'Male',
        [HumanEntrySex.FEMALE]: 'Female'
      },
      HumanEntryWearingType: {
        [HumanEntryWearingType.SINGLE_COLORED]: 'Single colored',
        [HumanEntryWearingType.PICTURED_CLOTHES]: 'With picture',
        [HumanEntryWearingType.STRIPED_CLOTHES]: 'Striped',
        [HumanEntryWearingType.PLAID_CLOTHES]: 'Plaid',
        [HumanEntryWearingType.OTHER_CLOTHES]: 'Other'
      },
      HumanEntryGlasses: {
        [HumanEntryGlasses.NONE]: 'None',
        [HumanEntryGlasses.NORMAL]: 'Normal lenses',
        [HumanEntryGlasses.BLACK]: 'Black lenses'
      },
      HumanEntryHair: {
        [HumanEntryHair.LONG_HIDING]: 'Long and hiding belt',
        [HumanEntryHair.SHORT]: 'Short'
      },
      LightConditionsType: {
        [LightConditionsType.DAY_TIME]: 'Daytime',
        [LightConditionsType.NIGHT_TIME]: 'Night',
        [LightConditionsType.GLARE]: 'Sun blight / glare',
        [LightConditionsType.DUSK]: 'Dusk'
      },
      LightConditionsSun: {
        [LightConditionsSun.NONE]: 'None',
        [LightConditionsSun.LEFT]: 'Left',
        [LightConditionsSun.RIGHT]: 'Right',
        [LightConditionsSun.BEHIND]: 'Behind',
        [LightConditionsSun.FRONT]: 'Front'
      },
      DetectorDirection: {
        [DetectorDirection.NONE]: 'None',
        [DetectorDirection.LEFT]: 'Left',
        [DetectorDirection.RIGHT]: 'Right'
      },
      DetectorFoodEat: {
        [DetectorFoodEat.NONE]: 'Nothing',
        [DetectorFoodEat.FRUIT]: 'Fruit',
        [DetectorFoodEat.SANDWICH]: 'Sandwich',
        [DetectorFoodEat.SMALL_FOOD]: 'Small food',
        [DetectorFoodEat.OTHER]: 'Other'
      },
      DetectorFoodDrink: {
        [DetectorFoodDrink.NONE]: 'Nothing',
        [DetectorFoodDrink.BOTTLE]: 'Bottle',
        [DetectorFoodDrink.GLASS]: 'Glass',
        [DetectorFoodDrink.CUP]: 'Cup',
        [DetectorFoodDrink.OTHER]: 'Other'
      },
      DetectorSmokeDirection: {
        [DetectorSmokeDirection.NONE]: 'No',
        [DetectorSmokeDirection.LEFT_HAND]: 'In the left hand',
        [DetectorSmokeDirection.RIGHT_HAND]: 'In the right hand',
        [DetectorSmokeDirection.MOUTH]: 'In the mouth'
      }
    }
  },
  shared: {
    abbreviation: {
      seconds: 's.',
      minutes: 'm.',
      hours: 'h.',
      days: 'd.'
    },
    send: 'Send',
    edit: 'Edit',
    save: 'Save',
    apply: 'Apply',
    search: 'Search',
    field: 'Field',
    value: 'Value'
  },
  charts: {
    criticalEventsDistribution: 'Critical events monthly distribution',
    criticalEventsDoughnut: 'Total critical events',
    driverSpecific: 'Driver choice',
    axis: {
      count: 'Count',
      date: 'Date'
    },
    filters: {
      title: 'Chart filters',
      date: {
        title: 'Trip time period'
      },
      period: {
        title: 'Chart time period',
        label: 'Period: ',
        minute: 'Minute',
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month'
      }
    }
  },
  reports: {
    title: 'Reports',
    datasetTitle: 'Critical dataset reports',
    emptySearchLabel: 'All drivers included',
    generateButton: 'Create report',
    criticalArchive: {
      title: 'Dataset photographs',
      download: 'Download archive'
    }
  },
  carParks: {
    title: 'Car parks management',
    header: 'Drivers',
    role: 'Role',
    after: 'Start of viewed trips range',
    before: 'End of viewed trips range',
    actions: 'Actions',
    restricted: 'Rights restricted?',
    roles: {
      [carParkRole.DRIVER]: 'Driver',
      [carParkRole.MANAGER]: 'Manager'
    },
    editForm: {
      titles: {
        create: 'Car park driver creation',
        update: 'Car park driver update'
      },
      autocompleteTitle: 'Driver',
      restrictedManager: 'Manager has restricted rights?'
    }
  },
  errors: {
    connectionRefused: 'Connection with server is not established!',
    generalError: 'Error has been occurred on the server side!',
    permissionsError: 'Permission denied for this operation!',
    unauthorizedError: 'Authorization required for the page access!',
    [BackendEndpoints.MAP_DRIVER_PROFILE]: {
      'user_id': 'Driver is not specified for settings fetching operation!',
      'profile': 'Driver profile is not found!',
      'settings': 'Driver settings is not found!'
    },
    [BackendEndpoints.SETTINGS_FETCH_DEFAULT]: {
      'default_settings': 'Default settings are not found on the server'
    }
  },

  sqlHelperDialog: {
    title: 'SQL Helper',
    pureEventsOld: 'Pure events (old)',
    pureEventsNew: 'Pure events (new)',
    criticalCurrent: 'Current critical event',
    criticalAll: 'All critical events'
  },

  // internal vuetify stuff
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.'
    }
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
    pageText: '{0}-{1} of {2}'
  },
  datePicker: {
    itemsSelected: '{0} selected'
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual'
  },
  calendar: {
    moreEvents: '{0} more'
  }
}
